module.exports = __webpack_public_path__ + "img/SpaceGray.63ed901d.jpg";